import React from "react";
import { FormattedMessage } from "react-intl";
import { ExclamationTriangleFill } from "react-bootstrap-icons";
import { NavLink } from "react-router-dom";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

import { useAlarm } from "../../../context/alarm/alarm";

export const NavbarAlarn = ({ className }) => {
  const {
    state: { task },
  } = useAlarm();

  if (task === null) {
    return null;
  }

  const tooltip = (
    <Tooltip>
      <div>
        <FormattedMessage
          id="data.alarm.label.onSiteServiceWorksheet.withcount"
          values={{ count: task.onSiteServiceWorksheet }}
        />
      </div>
      <div>
        <FormattedMessage
          id="data.alarm.label.notApproveonSiteServiceWorksheetTask.withcount"
          values={{ count: task.notApproveonSiteServiceWorksheetTask }}
        />
      </div>
      <div>
        <FormattedMessage
          id="data.alarm.label.servicewWorksheet.withcount"
          values={{ count: task.servicewWorksheet }}
        />
      </div>
      <div>
        <FormattedMessage
          id="data.alarm.label.email.withcount"
          values={{ count: task.email }}
        />
      </div>
    </Tooltip>
  );

  const getColor = () => {
    if (
      task.onSiteServiceWorksheet +
        task.servicewWorksheet +
        task.email +
        task.notApproveonSiteServiceWorksheetTask ===
      0
    ) {
      return "#808080";
    } else {
      return "red";
    }
  };

  return (
    <div className={className}>
      <OverlayTrigger placement="bottom" overlay={tooltip}>
        <NavLink to={`/alarms`}>
          <ExclamationTriangleFill
            color={getColor()}
            className="align-self-center"
          />
        </NavLink>
      </OverlayTrigger>
    </div>
  );
};
